export default "__VITE_ASSET__c4f11328__"